// extracted by mini-css-extract-plugin
export var brand = "_89-8";
export var compact = "_89-5";
export var extraSmall = "_89-6";
export var icon = "_89-0";
export var large = "_89-3";
export var light = "_89-1";
export var medium = "_89-4";
export var outline = "_89-a";
export var primaryDark = "_89-9";
export var primaryLight = "_89-7";
export var primaryModern = "_89-b";
export var success = "_89-2";